import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Navbar from 'src/components/common/navbar';
import Main from 'src/components/common/templates/main';

const MainContainer = styled.div`
  display: grid;
  grid-template-columns: var(--sidebar-width) 1fr;
  position: relative;
  height: 100vh;
  grid-template-areas:
    "navbar navbar navbar"
    "main main main";
`;

export const GlobalWrapper = styled.div`
  ${(p) => p.showBackDrop
    && css`
      filter: blur(2px);
    `};
`;

function AppWrapper({ children }) {
  return (
    <MainContainer>
      <Navbar />
      <Main>
        {children}
      </Main>
    </MainContainer>
  );
}

AppWrapper.propTypes = {
  children: PropTypes.node,
};

export default AppWrapper;
